import { create } from "zustand";

type IneligibleForCourierState = {
  hasItemIneligibleForCourier: boolean;
  hasSeenSwitchModal: boolean;
};

type IneligibleForCourierAction = {
  setHasItemIneligibleForCourier: (
    hasItemIneligibleForCourier: boolean,
  ) => void;
  setHasSeenSwitchModal: (hasSeenSwitchModal: boolean) => void;
};

export const useIneligibleForCourierStore = create<
  IneligibleForCourierState & IneligibleForCourierAction
>((set) => {
  return {
    hasItemIneligibleForCourier: false,
    setHasItemIneligibleForCourier: (hasItemIneligibleForCourier) =>
      set({ hasItemIneligibleForCourier }),
    hasSeenSwitchModal: false,
    setHasSeenSwitchModal: (hasSeenSwitchModal) => set({ hasSeenSwitchModal }),
  };
});
